import type { CSSProperties, ReactNode } from 'react';
import { cn } from './cn';

/** Ant Design `Divider` replacement — horizontal rule (optionally with centered text) or a vertical rule. */
export function Divider({
  type = 'horizontal', children, orientation = 'center', className, style, dashed,
}: {
  type?: 'horizontal' | 'vertical';
  children?: ReactNode;
  orientation?: 'left' | 'right' | 'center';
  className?: string;
  style?: CSSProperties;
  dashed?: boolean;
}) {
  if (type === 'vertical') {
    return <span className={cn('mx-2 inline-block h-[0.9em] w-px self-center bg-line align-middle', className)} style={style} />;
  }
  if (!children) {
    return <div className={cn('my-4 border-t border-line', dashed && 'border-dashed', className)} style={style} role="separator" />;
  }
  return (
    <div className={cn('my-4 flex items-center gap-3 text-sm font-medium text-muted', className)} style={style}>
      {orientation !== 'left' && <span className={cn('h-px flex-1 bg-line', dashed && 'border-t border-dashed bg-transparent')} />}
      <span className="shrink-0">{children}</span>
      {orientation !== 'right' && <span className={cn('h-px flex-1 bg-line', dashed && 'border-t border-dashed bg-transparent')} />}
    </div>
  );
}
